import React from 'react';
import { Box, keyframes, Text } from '@chakra-ui/react';

const marquee = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-300%);
  }
`;

const CenteredBox = () => {
  return (
    <Box
      px={{ base: '0', md: '0' }}
      pb={{ base: '2em', md: '2.5em' }}
      display="flex"
      justifyContent="center"
      alignItems="center"
      w="100%">

      <Box
        bg="white"
        p="5"
        w={{ base: '100%', md: '100%' }}
        textAlign="center"
        boxShadow="lg"
        overflow="hidden"
        position="relative"
      >
        <Text
          fontSize="2xl"
          color="red"
          fontFamily="'Fugaz One', sans-serif"
          textTransform="uppercase"
          fontWeight="bold"
          whiteSpace="nowrap"
          animation={{
            base: `${marquee} 10s linear infinite`, // Para móviles
            md: `${marquee} 25s linear infinite`,   // Para pantallas más grandes
          }}
          style={{textShadow:'0px 1px 1px black'}}
        >
          Like Seiya donning his Pegasus armor, we’re gearing up to blaze through the SEI chain—because true knights leave their mark in every cosmos! Like Seiya donning his Pegasus armor, we’re gearing up to blaze through the SEI chain—because true knights leave their mark in every cosmos!
        </Text>
      </Box>
    </Box>
  );
};

export default CenteredBox;
